import ActionList from "./ActionList";
import AlertBanner from "./AlertBanner";
import CalloutCard from "./CalloutCard";
import CodeDiffCard from "./CodeDiffCard";
import CollapsibleCard from "./CollapsibleCard";
import ComparisonCard from "./ComparisonCard";
import LinkCard from "./LinkCard";
import MentionCard from "../../MentionCard";
import MetricCard from "./MetricCard";
import ProgressIndicator from "./ProgressIndicator";
import SectionCard from "../../SectionCard";
import StatusTable from "./StatusTable";
import TimelineCard from "./TimelineCard";

// The optional third `ctx` argument carries behaviour the card can't own itself.
// Only dismissible cards use it today.
const CARD_RENDERERS = {
  mention: (card, key) => (
    <MentionCard key={key} name={card.data.name || ""} time={card.data.time || ""} context={card.data.context || ""} detail={card.data.detail || ""} />
  ),
  section: (card, key) => (
    <SectionCard key={key} type={card.data.type || "topics"} title={card.data.title || ""} content={card.data.content || []} />
  ),
  metric_card: (card, key) => (
    <MetricCard key={key} title={card.data.title} rows={card.data.rows} alert={card.data.alert} />
  ),
  action_list: (card, key) => (
    <ActionList key={key} title={card.data.title} items={card.data.items} />
  ),
  status_table: (card, key) => (
    <StatusTable key={key} title={card.data.title} headers={card.data.headers} rows={card.data.rows} highlightRows={card.data.highlightRows} />
  ),
  alert_banner: (card, key, ctx) => (
    <AlertBanner key={key} message={card.data.message} severity={card.data.severity} dismissible={card.data.dismissible} onDismiss={ctx?.onDismiss} />
  ),
  progress_indicator: (card, key) => (
    <ProgressIndicator key={key} label={card.data.label} current={card.data.current} max={card.data.max} unit={card.data.unit} />
  ),
  timeline: (card, key) => (
    <TimelineCard key={key} title={card.data.title} events={card.data.events} />
  ),
  collapsible: (card, key) => (
    <CollapsibleCard key={key} title={card.data.title} summary={card.data.summary} detail={card.data.detail} />
  ),
  comparison: (card, key) => (
    <ComparisonCard key={key} title={card.data.title} optionA={card.data.optionA} optionB={card.data.optionB} />
  ),
  code_diff: (card, key) => (
    <CodeDiffCard key={key} title={card.data.title} before={card.data.before} after={card.data.after} />
  ),
  link_card: (card, key) => (
    <LinkCard key={key} url={card.data.url} title={card.data.title} description={card.data.description} type={card.data.type} />
  ),
  callout: (card, key) => (
    <CalloutCard key={key} type={card.data.type} title={card.data.title} content={card.data.content} />
  ),
};

export default CARD_RENDERERS;
